module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.2528/img/spinner.png"